import * as negativeStatuses from '@/constants/negative_statuses';

export default {
  data() {
    return {
      useNullableNegativeStatus: true,
    };
  },
  computed: {
    negativeStatusesStatusItems() {
      const items = [];
      if (this.useNullableNegativeStatus) {
        items.push({
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
          value: null,
        });
      }
      Object.keys(negativeStatuses)
        .forEach((key) => {
          items.push({
            text: this.lang(this.$store, `sap/listings.global.filter.order_statuses.${negativeStatuses[key]}`),
            value: negativeStatuses[key],
          });
        });
      return items;
    },
  },
};
